import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { LoginRedirectPage } from '../components/login-wizard/models/login-redirect-page.enum';
import { AuthService } from '../services/auth.service';

@Injectable({
	providedIn: 'root'
})
export class MyWorkAuthGuard implements CanActivate {

	constructor(
		public auth: AuthService,
		public router: Router
	) { }

	canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
		return this.auth.isUserAuthenticated()
			.pipe(
				catchError(() => of(false)),
				tap(isAuthenticated => {
					if (!isAuthenticated) {
						location.href = `${location.origin}/login?page=${LoginRedirectPage.MyWork}&useMobile=1&isAutoredirect=true`;
					}
				})
			);
	}
}
